import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuidePillar,
  GuidePillarGrid,
} from "../GuideBlocks.js";

const FinalThoughtsSection = ({ heading, accentIndex = 1, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="final-thoughts"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Structured thinking is not about becoming less emotional. It is about becoming more intentional.
    </GuideLead>
    <p className="guide-panel__p">
      When you separate events from interpretations, seek evidence before drawing conclusions, and
      choose thoughtful responses over automatic reactions, your reasoning becomes clearer and your
      response discipline stronger.
    </p>
    <GuidePillarGrid columns={2}>
      <GuidePillar title="React to the story">
        Automatic, emotional, and often regretted.
      </GuidePillar>
      <GuidePillar title="Respond to the facts">
        Intentional, evidence-based, and strengthening over time.
      </GuidePillar>
    </GuidePillarGrid>
    <p className="guide-panel__p">
      The more often you choose the second, the stronger your thinking becomes. And stronger thinking
      leads to better decisions, fewer regretted reactions, and clearer conversations.
    </p>
    <GuideCallout variant="amber">
      Whenever your mind feels overwhelmed, remember four words:{" "}
      <strong>Event. Interpretation. Evidence. Response.</strong>
    </GuideCallout>
    <GuideCallout>
      That pause may be all you need to replace confusion with clarity.
    </GuideCallout>
  </GuidePanel>
);

export default FinalThoughtsSection;
